    $(function() {
        function formatDate(date) {
            return date.toLocaleDateString();
        }
    
        function isOneDayBefore(date1, date2) {
            var oneDayBefore = new Date(date2);
            oneDayBefore.setDate(date2.getDate() - 1);
            return formatDate(date1) === formatDate(oneDayBefore);
        }
    
        function addFirstDayClass(element) {
            $(element).addClass('new').append('<div class="first-day">New Deal!</div>');
        }
    
        function addOneDayBeforeClass(element) {
            $(element).addClass('day-before').append('<div class="ends-soon">Ends Soon!</div>');
        }
    
        function addLastDayClass(element) {
            $(element).addClass('expiring').append('<div class="last-day">Last Day!</div>');
        }

        function replaceNewWithExtendedClass(element) {
            $(element).removeClass('new').find('.first-day').remove();
            $(element).append('<div class="extended-tag">Deal Extended!</div>');
        }
    
        var d = new Date();
        var year = d.getUTCFullYear();
        var month = d.getUTCMonth() + 1;
        var date = d.getUTCDate();
        var hour = d.getUTCHours() - 5; // CHANGE DST HERE
        var mins = d.getUTCMinutes();
        var secs = d.getUTCSeconds();
    
        if (month < 10) month = '0' + month;
        if (date < 10) date = '0' + date;
        if (mins < 10) mins = '0' + mins;
        if (secs < 10) secs = '0' + secs;
    
        if (hour < 0) {
            date = date - 1;
            hour = hour + 24;
        }
        if (hour < 10) {
            hour = '0' + hour;
        }
        if (date < 1) {
            date = 31;
            month = month - 1;
        }

        if (month < 1) {
            month = 12;
            year = year - 1;
        }
    
        var today = month + "/" + date + "/" + year;
        var est = month + "/" + date + "/" + year + " " + hour + ":" + mins + ":" + secs;
        console.log('DateTime now: ' + est);
        est = new Date(est);
    
        $(".deal-box").each(function() {
            var expiryDate = new Date($(this).data('expiry'));
            var startDate = new Date($(this).data('start'));
    
            if (est.getTime() > expiryDate.getTime() || est.getTime() < startDate.getTime()) {
                $(this).remove();
                return; // Skip the rest of the loop for removed elements
            } else {
                $(this).show();
            }
    
            if (isOneDayBefore(new Date(), expiryDate)) {
                addOneDayBeforeClass(this);
            }
    
            if (formatDate(est) === formatDate(expiryDate)) {
                addLastDayClass(this);
            }

    
            if ($(this).hasClass('extended')) {
                replaceNewWithExtendedClass(this);
            } else if (formatDate(est) === formatDate(startDate)) {
                addFirstDayClass(this);
            }
        });
    
        $(".deal-box").delay(200).animate({ opacity: 1 }, 700);
    });

    $(function () {
    $('.deal-box a').click(function () {
        document.getElementsByClassName('spinner')[0].style.display = 'flex';
    });
});

function moveLastChildIfOdd() {
    const parents = document.querySelectorAll('.deals-wrapper');
    for (let i = 0; i < parents.length - 1; i++) {
        const currentParent = parents[i];
        const nextParent = parents[i + 1];
        const children = currentParent.children;
        if (children.length % 2 !== 0) {
            nextParent.prepend(children[children.length - 1]);
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    moveLastChildIfOdd();
});